export var PaymentType;
(function (PaymentType) {
    PaymentType["ONLINE"] = "ONLINE";
    PaymentType["OFFLINE"] = "OFFLINE";
    PaymentType["BOTH"] = "BOTH";
})(PaymentType || (PaymentType = {}));
//# sourceMappingURL=service-payment.dto.js.map